import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
	AbstractControl,
	FormArray,
	FormBuilder,
	FormGroup,
	Validators,
} from "@angular/forms";
import { ConfirmationService } from "primeng/api";
import { Table } from "primeng/table";
import { Utils } from "src/app/app.utils";
import { User } from "src/app/core/endpoints/models/user.model";
import { ApiService } from "src/app/core/services/api.service";
import { ToastService } from "src/app/core/services/toast.service";
import { confirmPassword } from "src/app/core/utils/utils";
import * as moment from "moment";
import "moment/locale/es";
import { ImageCropperComponent, ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { Router } from "@angular/router";

@Component({
	selector: "app-users",
	templateUrl: "./users.component.html",
	styleUrls: ["./users.component.scss"],
})
export class UsersComponent implements OnInit {
	@ViewChild("dt") table: Table;
	@ViewChild("filter") filter: ElementRef;

	imageChangedEvent: Event | null = null;
	croppedActive: boolean  = false;

	public user: any;

	public role_ids: any[] | undefined;
	public users: User[] = [];
	public loading: boolean = false;
	public dialogUser: boolean = false;
	public mode: "edit" | "register" = "edit";
	public photo: File;
	public stringPhoto: string = null;
	public userSelected: User;
	public isDropDownDisabled:boolean = false;

	form: FormGroup = this.fb.group({
		name: [
			"",
			[Validators.required],
		],
		surname: [
			"",
			[Validators.required],
		],
		email: ["", [Validators.required, Validators.email]],
		password: [""],
		password_confirmation: [""],
		phone_number: ["", Validators.pattern("^[0-9]+$")],
		role_id: ["",[Validators.required]],
		avatar: [""],
		color: ["FF0000"],
		number_document: [""]
	});

	constructor(
		private apiService: ApiService,
		private fb: FormBuilder,
		private toast: ToastService,
		private confirmationService: ConfirmationService,
		public router: Router
	) {
	}

	ngOnInit(): void {
		this.role_ids = [
			{ name: "Seleccione", value: null }
		];
		this.getUser();
	}
	

	getUser(){
		this.user = JSON.parse(localStorage.getItem("user"));
		if(this.user.role_id === 2 || this.user.role_id === 3){
			this.form.patchValue({role_id: 4});
			this.form.get('role_id')?.updateValueAndValidity();
			this.isDropDownDisabled = true;
		}


		if(this.router.url.includes('usersWorker')){
			this.role_ids = [
				{ name: "Seleccione", value: null },
				{ name: "Trabajador", value: 2 }
			];
			this.form.patchValue({role_id: 2});
			this.form.get('role_id')?.updateValueAndValidity();
		}else if(this.router.url.includes('usersBilling')){
			this.role_ids = [
				{ name: "Seleccione", value: null },
				{ name: "Facturación", value: 3 }
			];
			this.form.patchValue({role_id: 3});
			this.form.get('role_id')?.updateValueAndValidity();
		}else{
			this.role_ids = [
				{ name: "Cliente", value: 4 },
			];
			this.form.patchValue({role_id: 4});
			this.form.get('role_id')?.updateValueAndValidity();
		}

		this.loadUsers();
	}

	/**
	 * Obtener listado de clientes registrados
	 */
	public loadUsers() {
		this.loading = true;
		if (this.user.role_id == 1){
			var route = "users";
			var valueRoute = 4;
			if(this.router.url.includes('usersWorker')){
				route = "usersWorker";
				valueRoute = null;
			}
			if(this.router.url.includes('usersBilling')){
				route = "usersBilling";
				valueRoute = null;
			}
			this.apiService.getEntity(route,valueRoute).subscribe({
				next: (result) => {
					this.users = result.users;
					this.users = this.users.map((user) => ({
						...user,
						role_id_string: user.role_id === 1 ? "Admin" : user.role_id === 2 ? "Trabajador": user.role_id === 3 ? "Facturación": "Cliente",
						status_string: user.status === 1 ? "Activo" : "Desactivado",
					}));
				},
				error: (err) => {
					this.loading = false;
					console.log(err);
				},
				complete: () => {
					this.loading = false;
				},
			});
		}else{
			this.apiService.getEntity("users", 4).subscribe({
				next: (result) => {
					this.users = result.users;
					this.users = this.users.map((user) => ({
						...user,
						role_id_string: user.role_id === 1 ? "Admin" : user.role_id === 2 ? "Trabajador": user.role_id === 3 ? "Facturación": "Cliente",
						status_string: user.status === 1 ? "Activo" : "Desactivado",
					}));
				},
				error: (err) => {
					this.loading = false;
					console.log(err);
				},
				complete: () => {
					this.loading = false;
				},
			});
		}
	}

	/**
	 * Limpiar filtros de búsqueda
	 * @param table
	 */
	public clear(table: Table) {
		table.clear();
		this.filter.nativeElement.value = "";
	}

	/**
	 * Registrar nuevo usuario de tipo cliente para la app
	 */
	public registerUser() {
		this.form.get('role_id')?.updateValueAndValidity();

		if(this.user.role_id === 2 || this.user.role_id === 3){
			this.form.patchValue({role_id: 4});
			this.isDropDownDisabled = true;
		}else{
			this.isDropDownDisabled = false;
		}

		if (this.form.value.role_id === 4){
			this.form.patchValue({number_document: null});
		}
		this.form.markAllAsTouched();
		if (this.form.invalid) {
			return this.toast.show(
				"Aviso",
				"Revise los datos del formulario",
				"warn"
			);
		}

		this.loading = true;
		
		this.form.patchValue({avatar: this.stringPhoto  });

		this.apiService
			.addEntity("registerUserFromAdmin", this.form.value)
			.subscribe({
				next: (result) => {
					this.dialogUser = false;
					this.toast.show("Cliente creado correctamente");
					this.loadUsers();
					this.croppedActive = false;
				},
				error: (err) => {
					let message = "Ocurrió un error al crear el usuario, inténtelo de nuevo";
					if (err && err.error && err.error.errors){
						message = '';
						let errors = err.error.errors;
						for (const field in errors) {
							errors[field].forEach((errorMessage) => {
								message += `${errorMessage}\n`;
							});
						}
					}
					this.loading = false;
					this.toast.show(
						"Error",
						message,
						"error"
					);
				},
				complete: () => {
					this.loading = false;
				},
			});
	}

	/**
	 * Actualizar usuario existente
	 */
	public updateUser() {
		this.form.markAllAsTouched();
		if (this.form.invalid) {
			return this.toast.show("Aviso", "Revise el formulario", "warn");
		}
		
		this.loading = true;
		if(this.user.role_id === 2 || this.user.role_id === 3){
			this.form.patchValue({role_id: 4});
			this.form.get('role_id')?.updateValueAndValidity();
			this.isDropDownDisabled = true;
		}
		
		if (this.form.value.role_id !== 4){
			this.form.patchValue({number_document: null});
		}

		this.form.patchValue({ avatar: this.stringPhoto });

		this.apiService
			.updateEntity(
				"updateUserFromAdmin",
				this.userSelected.id,
				this.form.value
			)
			.subscribe({
				next: (result) => {
					this.loading = false;
					this.form.reset();
					this.toast.show("Cliente actualizado correctamente");
					this.dialogUser = false;
					this.loadUsers();
					this.croppedActive = false;
				},
				error: (err) => {
					this.loading = false;
					let message = "Ocurrió un error al editar el usuario, inténtelo de nuevo";
					if (err && err.error && err.error.errors){
						message = '';
						let errors = err.error.errors;
						for (const field in errors) {
							errors[field].forEach((errorMessage) => {
								message += `${errorMessage}\n`;
							});
						}
					}
					this.loading = false;
					this.toast.show(
						"Error",
						message,
						"error"
					);
				},
				complete: () => {
					this.loading = false;
				},
			});
	}

	/**
	 * Eliminar usuario existente
	 */
	public deleteUser(user: User) {
		if (this.loading) return;
		this.confirmationService.confirm({
			target: event.target,
			message: "¿Está seguro que desea eliminar el usuario?",
			icon: "pi pi-exclamation-triangle",
			accept: () => {
				this.loading = true;
				this.apiService.deleteEntity("deleteUserFromAdmin", user.id).subscribe({
					next: () => {
						this.loading = false;
						this.toast.show("Cliente eliminado correctamente");
						this.loadUsers();
					},
					error: () => {
						this.loading = false;
						this.toast.show(
							"Error",
							"Ocurrió un error eliminando el usuario, inténtelo de nuevo",
							"error"
						);
					},
				});
			},
		});
	}

	/**
	 * Mostrar modal para añadir/editar usuario
	 */
	public showDialog(user?: User) {
		if (user) {
			this.userSelected = user;
			this.form.patchValue(user);
			if (this.userSelected){
				this.stringPhoto = this.form.get("avatar").value;
			}
			this.form.setControl('password', this.fb.control(""));
			this.form.setControl('password_confirmation', this.fb.control(""));
		}else{
			this.form.setControl('password', this.fb.control("", [Validators.required]));
			this.form.setControl('password_confirmation', this.fb.control("", [Validators.required, confirmPassword]));
		}

		this.mode = user ? "edit" : "register";
		this.dialogUser = true;
	}

	/**
	 * Activar/desactivar cuenta de usuario
	 * @param user
	 */
	public updateStatus(user: User) {
		this.loading = true;
		this.apiService
			.updateEntity("updateUserStatusFromAdmin", user.id, {
				user: user,
				status: user.status === 0 ? 1 : 0,
			})
			.subscribe({
				next: (result) => {
					this.loading = false;
				},
				error: (err) => {
					console.log(err);
				},
				complete: () => {
					this.loadUsers();
					this.loading = false;
				},
			});
	}

	/**
	 * Eliminar imagen del formulario
	 */
	public deletePhoto() {
		this.stringPhoto = undefined;
		this.croppedActive = false;
	}

	/**
	 * Reinicio de formulario
	 */
	public resetForm() {
		this.form.reset();
		this.stringPhoto = undefined;
	}

	/**
	 * Tratar imagen adjuntada al formulario
	 * @param $event
	 * @returns
	 */
	public handleUpload($event: any) {
		this.imageChangedEvent = $event;
		this.croppedActive = true;
		// try {
		// 	const files: FileList = $event.target.files;
		// 	this.photo = Utils.renameFile(files[0], new Date().getTime().toString());
		// 	var reader = new FileReader();
		// 	if (this.photo.type === "image/jpeg" || this.photo.type === "image/png") {
		// 		reader.onloadend = async () => {
		// 			$event.target.value = "";
		// 			this.stringPhoto = String(reader.result);
		// 		};
		// 		reader.readAsDataURL(this.photo);
		// 	} else {
		// 		return this.toast.show(
		// 			"Aviso",
		// 			"El formato de la imagen debe ser PNG o JPG",
		// 			"warn"
		// 		);
		// 	}
		// } catch (error) {
		// 	console.log(error);
		// }
	}
	
    imageCropped(event: ImageCroppedEvent) {
      this.stringPhoto = event.base64;
    }
    imageLoaded(image: LoadedImage) {
    }
    cropperReady() {
    }
    loadImageFailed() {
    }
}
